import { kebabCase, pascalCase } from 'change-case'
import { Navigate, useParams } from 'react-router-dom'

import { PerformanceProductPage } from 'features/performance/pages/PerformanceProductPage'
import { productTypeValues } from 'features/product/types/product'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes/routePaths'

import type { Product } from 'features/product'
import type { PascalCase } from 'type-fest'

export const AuthorizedPerformanceProductRoute = (): React.JSX.Element => {
  const ability = useAbility()
  const { product: productSlug } = useParams<{ product: string }>()

  const product: Product | undefined = productTypeValues.find(
    (product: Product): boolean => kebabCase(product) === productSlug,
  )

  const notFoundRoute: string = ROUTES.BASE.NOT_FOUND

  if (product === undefined) {
    return <Navigate to={notFoundRoute} />
  }

  const hasAccess =
    ability.can('access', `Product-${product}`) &&
    ability.can('access', `Performance${pascalCase(product) as PascalCase<Product>}Page`)

  if (hasAccess) {
    return <PerformanceProductPage />
  } else {
    return <Navigate to={notFoundRoute} />
  }
}
